import angular from 'angular';

export class FeatureCouponsService {
  static $inject = [];

  readonly name = 'coupons';
  readonly key = 'enableCoupons';
}

export const FeatureCouponsServiceModule = angular
  .module('acme.common.service.feature.coupons', [])
  .service('FeatureCouponsService', FeatureCouponsService).name;
